<div class="tw-py-[0.3125rem]">
  @if (
    !selectFlightState.selectedSmartCombo() &&
    selectFlightState.selectedFlight()
  ) {
    <div class="tw-mb-2.5">
      <span
        class="tw-my-2.5 tw-inline-block tw-text-[0.9375rem] tw-text-success"
      >
        1. Chiều đi:
      </span>
      <div class="tw-overflow-x-auto">
        <ng-container
          [ngTemplateOutlet]="content"
          [ngTemplateOutletContext]="{
            priceData: flightPriceData(),
            newPriceData: flightTotalPriceChange(),
            ancillaries: flightAncillaries(),
          }"
        ></ng-container>
      </div>
    </div>
  }

  @if (
    !selectFlightState.selectedSmartCombo() &&
    selectFlightState.roundTrip() &&
    selectFlightState.selectedRoundTripFlight()
  ) {
    <div class="tw-mb-2.5">
      <span
        class="tw-my-2.5 tw-inline-block tw-text-[0.9375rem] tw-text-success"
      >
        2. Chiều về:
      </span>
      <div class="tw-overflow-x-auto">
        <ng-container
          [ngTemplateOutlet]="content"
          [ngTemplateOutletContext]="{
            priceData: roundTripFlightPriceData(),
            newPriceData: roundTripFlightTotalPriceChange(),
            ancillaries: roundTripFlightAncillaries(),
          }"
        ></ng-container>
      </div>
    </div>
  }

  @if (
    selectFlightState.showSmartCombo() && selectFlightState.selectedSmartCombo()
  ) {
    <div class="tw-mb-2.5">
      <span
        class="tw-my-2.5 tw-inline-block tw-text-[0.9375rem] tw-text-success"
      >
        1. Combo khứ hồi:
      </span>
      <div class="tw-overflow-x-auto">
        <ng-container
          [ngTemplateOutlet]="content"
          [ngTemplateOutletContext]="{
            priceData: flightPriceData(),
            newPriceData: flightTotalPriceChange(),
          }"
        ></ng-container>
      </div>
    </div>
  }
</div>

<ng-template
  #content
  let-priceData="priceData"
  let-newPriceData="newPriceData"
  let-ancillaries="ancillaries"
>
  <table class="tw-w-full tw-text-sm">
    <thead class="tw-bg-success tw-text-success-content">
      <tr class="tw-border tw-border-success">
        <th
          class="tw-w-[30%] tw-max-w-[30%] tw-border-r tw-border-current tw-p-1"
        >
          Hành khách
        </th>
        <th class="tw-border-r tw-border-current tw-p-1 tw-text-end">Giá vé</th>
        <th class="tw-border-r tw-border-current tw-p-1 tw-text-end">
          Thuế phí
        </th>
        <th class="tw-border-r tw-p-1 tw-text-end">Tổng giá</th>
      </tr>
    </thead>
    <tbody>
      @if (selectFlightState.adult() > 0) {
        <tr class="tw-border-b tw-border-success hover:tw-bg-base-100">
          <td class="tw-border-l tw-border-success tw-p-1 last:tw-border-r">
            Người lớn
            <span class="tw-font-bold">(x{{ selectFlightState.adult() }})</span>
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            <div class="tw-flex tw-flex-col">
              @if (priceData.originalAdult > 0) {
                <span class="tw-leading-none tw-text-base-500">
                  <span class="tw-text-xs tw-line-through">
                    {{ priceData.originalAdult | number }}
                  </span>
                </span>
              }
              <span>
                {{ priceData.adult?.price ?? 0 | number }}
              </span>
            </div>
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            {{
              (priceData.adult?.tax ?? 0) + (priceData.adult?.fee ?? 0) | number
            }}
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            {{
              ((priceData.adult?.price ?? 0) +
                (priceData.adult?.tax ?? 0) +
                (priceData.adult?.fee ?? 0)) *
                selectFlightState.adult() | number
            }}
          </td>
        </tr>
      }

      @if (selectFlightState.child() > 0) {
        <tr class="tw-border-b tw-border-success hover:tw-bg-base-100">
          <td class="tw-border-l tw-border-success tw-p-1 last:tw-border-r">
            Trẻ em
            <span class="tw-font-bold">(x{{ selectFlightState.child() }})</span>
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            <div class="tw-flex tw-flex-col">
              @if (priceData.originalChild > 0) {
                <span class="tw-leading-none tw-text-base-500">
                  <span class="tw-text-xs tw-line-through">
                    {{ priceData.originalChild | number }}
                  </span>
                </span>
              }
              <span>
                {{ priceData.child?.price ?? 0 | number }}
              </span>
            </div>
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            {{
              (priceData.child?.tax ?? 0) + (priceData.child?.fee ?? 0) | number
            }}
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            {{
              ((priceData.child?.price ?? 0) +
                (priceData.child?.tax ?? 0) +
                (priceData.child?.fee ?? 0)) *
                selectFlightState.child() | number
            }}
          </td>
        </tr>
      }

      @if (selectFlightState.infant() > 0) {
        <tr class="tw-border-b tw-border-success hover:tw-bg-base-100">
          <td class="tw-border-l tw-border-success tw-p-1 last:tw-border-r">
            Em bé
            <span class="tw-font-bold">
              (x{{ selectFlightState.infant() }})
            </span>
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            <div class="tw-flex tw-flex-col">
              @if (priceData.originalInfant > 0) {
                <span class="tw-leading-none tw-text-base-500">
                  <span class="tw-text-xs tw-line-through">
                    {{ priceData.originalInfant | number }}
                  </span>
                </span>
              }
              <span>
                {{ priceData.infant?.price ?? 0 | number }}
              </span>
            </div>
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            {{
              (priceData.infant?.tax ?? 0) + (priceData.infant?.fee ?? 0)
                | number
            }}
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            {{
              ((priceData.infant?.price ?? 0) +
                (priceData.infant?.tax ?? 0) +
                (priceData.infant?.fee ?? 0)) *
                selectFlightState.infant() | number
            }}
          </td>
        </tr>
      }

      @for (item of ancillaries; track $index) {
        <tr class="tw-border-b tw-border-success hover:tw-bg-base-100">
          <td
            class="tw-break-all tw-border-l tw-border-success tw-p-1 last:tw-border-r"
          >
            {{ item.name }}
            <span class="tw-font-bold">(x{{ item.count }})</span>
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            {{ item.price | number }}
          </td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          ></td>
          <td
            class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
          >
            {{ item.totalPrice | number }}
          </td>
        </tr>
      }

      <tr
        class="tw-border-b tw-border-success tw-font-bold hover:tw-bg-base-100"
      >
        <td class="tw-border-l tw-border-success tw-p-1 last:tw-border-r">
          Tổng cộng
        </td>
        <td
          class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
        ></td>
        <td
          class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
        ></td>
        <td
          class="tw-border-l tw-border-success tw-p-1 tw-text-end last:tw-border-r"
        >
          @if (!newPriceData) {
            <div>
              {{
                ((priceData.adult?.price ?? 0) +
                  (priceData.adult?.tax ?? 0) +
                  (priceData.adult?.fee ?? 0)) *
                  selectFlightState.adult() +
                  ((priceData.child?.price ?? 0) +
                    (priceData.child?.tax ?? 0) +
                    (priceData.child?.fee ?? 0)) *
                    selectFlightState.child() +
                  ((priceData.infant?.price ?? 0) +
                    (priceData.infant?.tax ?? 0) +
                    (priceData.infant?.fee ?? 0)) *
                    selectFlightState.infant() +
                  priceData.ancillaries | number
              }}
            </div>
          } @else {
            <div class="tw-line-through">
              {{ newPriceData?.current ?? 0 | number }}
            </div>
            <div>
              {{ newPriceData?.new ?? 0 | number }}
            </div>
          }
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>
